<template>
    <div class="withdrawCheck">
        <el-card class="box-card">
            <div slot="header" class="withDrawCheckTitle">
                <el-row :gutter="15">
                    <el-col :span="24">
                        <el-col :span="6" :class="{floatRightStyle: $i18n.locale === 'ae'}">
                            <span>{{$t('home.withDrawCheck')}}</span>
                        </el-col>
                        <el-col :span="18" style="text-align:right;">
                            <span class="checkKey">
                                <el-input v-model="keyWord" :placeholder="$t('placeholder.enterKeyword')" style="margin-right:5px;" @keyup.native.enter="reloadWithdrawList"></el-input>
                            </span>
                            <el-select v-model="withdrawStatus" @change="selectWithdraw" clearable :placeholder="$t('home.selectAppStatus')">
                                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                            <el-button type="primary" @click="toReportExcel" :loading="exportLoading" style="margin-left: 5px;">{{$t('other.exportExcel')}}</el-button>
                        </el-col>
                    </el-col>
                </el-row>
                <!-- <span>{{$t('home.withDrawCheck')}}</span>
                <el-button type="primary" @click="toReportExcel" :loading="exportLoading" style="margin-left: 5px;" :style="{float: $i18n.locale === 'ae'?'left':'right'}">{{$t('other.exportExcel')}}</el-button>
                <el-select v-model="withdrawStatus" @change="selectWithdraw" clearable style="float: right;" :placeholder="$t('home.selectAppStatus')">
                    <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <span class="checkKey">
                    <el-input v-model="keyWord" :placeholder="$t('placeholder.enterKeyword')" style="margin-right:5px;float: right;" @keyup.native.enter="reloadWithdrawList"></el-input>
                </span> -->
            </div>
            <div class="applyTable" v-loading="checkLoading">
                <el-table :data="tableData" ref="withdrawList" style="width: 100%" stripe border :height="userTableHeight">
                    <el-table-column v-for="(item,index) in tableHead" :key="index" :label="item.labelName" :prop="item.propName" :min-width="item.width" show-overflow-tooltip v-show="item.isShow">
                        <template slot-scope="scope">
                            <span v-if="item.propName == 'STATUS'">
                                <span v-show="scope.row.STATUS === '0'">
                                    <el-tag size="small">{{$t('home.inHand')}}</el-tag>
                                </span>
                                <span v-show="scope.row.STATUS === '1'">
                                    <el-tag type="success" size="small">{{$t('home.figureOut')}}</el-tag>
                                </span>
                                <span v-show="scope.row.STATUS === '2'">
                                    <el-tooltip class="item" effect="dark" :content="scope.row.UPDATE_REASON ? scope.row.UPDATE_REASON : $t('other.noReason')" placement="top" popper-class="user-tooltip">
                                        <el-tag  type="danger" size="small">{{$t('home.rejected')}}</el-tag>
                                    </el-tooltip>
                                </span>
                                <span v-show="scope.row.STATUS === '3'">
                                    <el-tag type="warning" size="small">{{$t('home.canceled')}}</el-tag>
                                </span>
                            </span>
                            <span v-else-if="item.propName == 'LOGIN'">
                                <el-tooltip class="withdrawCountTip" effect="dark" :content="scope.row.WITHDRAW_COUNT == '0' ? $t('other.firstWithdraw') : $t('other.isWithdrawed') + scope.row.WITHDRAW_COUNT + $t('other.time')" placement="top-start">
                                    <span v-if="scope.row.WITHDRAW_COUNT == '0'">
                                        <!-- <span class="el-icon-my-iconcj"></span> -->
                                        <img :src="require(`@/assets/img/zero.svg`)" style="height: 21px;vertical-align: middle;" />
                                    </span>
                                    <span class="countIcon" v-else>{{scope.row.WITHDRAW_COUNT}}</span>
                                </el-tooltip>
                                <el-tooltip class="withdrawCountTip" effect="dark" :content="scope.row.CARD_STATUS == '1' ? $t('other.checked') : $t('other.noChecked')" placement="top-start">
                                    <span class="el-icon-my-approve successCharge" v-if="scope.row.CARD_STATUS == '1'"></span>
                                    <span class="el-icon-my-weirenzheng warningCharge" v-else ></span>
                                </el-tooltip>
                                <el-tooltip class="withdrawCountTip" placement="right" popper-class="negativeTooltip">
                                    <div slot="content" class="negativeDetail">
                                        <el-table :data="scope.row.NEGATIVE_LOGIN" style="width: 100%" border>
                                            <el-table-column prop="LOGIN" :label="$t('table.username')"></el-table-column>
                                            <el-table-column prop="BALANCE" :label="$t('table.balance')"></el-table-column>
                                        </el-table>
                                    </div>
                                    <span class="negative countIcon" v-if="scope.row.NEGATIVE_STATUS == '1'">{{$t('other.minus')}}</span>
                                    <span class="negative countIcon" v-else>{{$t('other.plus')}}</span>
                                </el-tooltip>

                                <span class="holder-class" @click="showBalanceRecord(scope.row)">{{scope.row.LOGIN}}</span>
                            </span>
                            <div v-else-if="item.propName == 'CHARGE'">
                                <el-input v-model="scope.row.chargeValue" class="chargeEdit" :class="{successCharge: scope.row.CARD_STATUS,warningCharge: !scope.row.CARD_STATUS}" @change="toEditCharge(scope.row)">
                                    <i class="el-icon-edit el-input__icon iconEdit" slot="suffix" @click="toEditCharge(scope.row)"></i>
                                </el-input>
                            </div>
                            <span v-else>{{scope.row[item.propName] ? scope.row[item.propName] : '-'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column class-name="operation-class" :label="$t('table.operate')" :min-width="250" v-if="!withdrawStatus" fixed="right">
                        <template slot-scope="scope">
                            <span @click="toEditWithdraw(scope.row)">
                                <el-button size="mini">{{$t('button.edit')}}</el-button>
                            </span>
                            <span @click="toSubmitWithdraw(scope.row)">
                                <el-button type="primary" size="mini" :loading="scope.row.affirmBtnLoading">{{$t('button.affirm')}}</el-button>
                            </span>
                            <span @click="toRejectWithdraw(scope.row)">
                                <el-button type="danger" size="mini" :loading="scope.row.refuseBtnLoading">{{$t('button.refuse')}}</el-button>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="applyPage">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10,15,20,30 ,50,100,200]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </el-card>
        <!-- 修改出金申请信息 dialog -->
        <el-dialog :title="$t('dialog.editWithdraw')" :visible.sync="editVisible" width="80%" :before-close="handleClose" top="12vh">
            <div v-loading="editLoading">
                <div class="editWithdraw">
                    <el-row :gutter="15">
                        <el-form :model="editWithdrawForm" ref="editWithdrawForm" :rules="editRules">
                            <el-col :span="12">
                                <el-form-item :label="$t('home.holderName')" prop="login_holder">
                                    <el-input v-model="editWithdrawForm.login_holder" :placeholder="$t('home.enterHolderName')" disabled></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('home.accountNumber')" prop="username">
                                    <el-input v-model="editWithdrawForm.username" :placeholder="$t('home.enterAccountNumber')" disabled></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('home.currency')" prop="currency">
                                    <el-select v-model="editWithdrawForm.currency" clearable :placeholder="$t('home.selectCurrency')">
                                        <el-option v-for="item in currencyOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('home.amount')" prop="amount">
                                    <el-input v-model="editWithdrawForm.amount" :placeholder="$t('home.enterAmount')"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('home.charge')" prop="charge">
                                    <el-input v-model="editWithdrawForm.charge" :placeholder="$t('home.enterCharge')"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_bank_account')" prop="card_number">
                                    <el-input v-model="editWithdrawForm.card_number" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_bank_name')" prop="bank_name">
                                    <el-input v-model="editWithdrawForm.bank_name" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_beneficiary')" prop="beneficiary_name">
                                    <el-input v-model="editWithdrawForm.beneficiary_name" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_swift')" prop="swift_code">
                                    <el-input v-model="editWithdrawForm.swift_code" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_receving')" prop="info_type">
                                    <el-select v-model="editWithdrawForm.info_type" clearable @change="recevingChange">
                                        <el-option v-for="(v,i) in recevingOptions" :key="i" :label="v.label" :value="v.value" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="" prop="info_value" ref="info_value">
                                    <el-input v-model="editWithdrawForm.info_value" :placeholder="$t('withdraw.draw_corres')" :disabled="!editWithdrawForm.info_type"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('withdraw.draw_bank_address')" prop="bank_address1">
                                    <el-input v-model="editWithdrawForm.bank_address1" :placeholder="$t('withdraw.draw_add_1')"></el-input>
                                </el-form-item>
                                <el-form-item label="" prop="bank_address2">
                                    <el-input v-model="editWithdrawForm.bank_address2" :placeholder="$t('withdraw.draw_add_2')"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_country')" prop="bank_country">
                                    <el-input v-model="editWithdrawForm.bank_country" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_city')" prop="bank_city">
                                    <el-input v-model="editWithdrawForm.bank_city" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_post_code')" prop="post_code">
                                    <el-input v-model="editWithdrawForm.post_code" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item label="" prop="require_intermediary" style="text-align: left;">
                                    <el-checkbox v-model="editWithdrawForm.require_intermediary" :label="$t('withdraw.draw_intermediary')" border @change="intermediaryChange"></el-checkbox>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_inter_name')" prop="intermediary_bank_name" ref="intermediary_bank_name">
                                    <el-input v-model="editWithdrawForm.intermediary_bank_name" placeholder="" :disabled="!editWithdrawForm.require_intermediary"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_country')" prop="intermediary_country_code" ref="intermediary_country_code">
                                    <el-input v-model="editWithdrawForm.intermediary_country_code" placeholder="" :disabled="!editWithdrawForm.require_intermediary"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_swift')" prop="intermediary_swift_code" ref="intermediary_swift_code">
                                    <el-input v-model="editWithdrawForm.intermediary_swift_code" placeholder="" :disabled="!editWithdrawForm.require_intermediary"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('withdraw.draw_add_info')" prop="additional_information">
                                    <el-input v-model="editWithdrawForm.additional_information" placeholder=""></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form>
                    </el-row>
                </div>
                <div style="text-align: right;">
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="handleClose">{{$t('button.cancle')}}</el-button>
                        <el-button type="primary" @click="editSubmit">{{$t('button.confirm')}}</el-button>
                    </span>
                </div>
            </div>
        </el-dialog>
        <!-- dialog 余额变动记录 -->
		<el-dialog title="" :visible.sync="recordVisible" width="90%" :before-close="recordClose" custom-class="recordDialog">
			<div class="recordTitle" slot="title" >
                <span style="display: inline-block;">
                    <el-input v-model="recordKeyword" :placeholder="$t('placeholder.enterKeyword')" @keyup.native.enter="reloadRecordList"></el-input>
                </span>
				<el-date-picker v-model="dateValue" @change="changeDate" type="daterange" align="right" unlink-panels :range-separator="$t('button.to')" :start-placeholder="$t('button.startDate')" :end-placeholder="$t('button.endDate')" value-format="yyyy-MM-dd" style="margin-left: 10px;"></el-date-picker>
			</div>
			<div class="dialogContent" v-loading="recordLoading">
                <div class="historySum" v-for="(item,index) in countData" :key="index">
                    <span :style="{fontSize: '12px'}" :class="{sumLabelFont: index == 0 ? false : true}">{{item.label}}</span><span class="sumNumberFont">{{item.value}}</span>
                </div>
				<el-table :data="recordTable" ref="recordTable" style="width: 100%" stripe border height="430">
                    <el-table-column v-for="(item,index) in recordTableHead" :key="index" :label="item.labelName" :prop="item.propName" :min-width="item.width"></el-table-column>
                </el-table>
                <div class="recordPage">
                    <el-pagination
                        @size-change="recordSizeChange"
                        @current-change="recordCurrentChange"
                        :current-page="recordCurrentPage"
                        :page-sizes="[10,15,20,30 ,50,100,200]"
                        :page-size="recordPageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="recordTotal">
                    </el-pagination>
                </div>
			</div>
		</el-dialog>
    </div>
</template>
<script>
import { withdrawCheckList , withdrawSubmit, withdrawReject , editWithdraw , updateCharge } from "@/api/money/money"
import { getNewBalance , getBalanceRecord } from "@/api/user/user"
import { exportExcelMethod , copyArr } from '@/utils/exportExcel'
export default {
    name:'withdrawCheck',
      data() {
        return {
            tableData: [],
            tableHead: [
                { propName: 'LOGIN',labelName: this.$t('home.accountNumber'),width: '150',isShow: true },
                { propName: 'LOGIN_HOLDER',labelName: this.$t('home.holderName'),width: '160',isShow: true },
                { propName: 'FULL_NAME',labelName: this.$t('home.payeeName'),width: '100',isShow: true },
                { propName: 'AMOUNT',labelName: this.$t('home.amount'),width: '100',isShow: true },
                { propName: 'CHARGE',labelName: this.$t('home.charge'),width: '170',isShow: true },
                /* { propName: 'BANK_PROVINCE',labelName: this.$t('home.province'),width: '100' },
                { propName: 'BANK_CITY',labelName: this.$t('home.city'),width: '100' },
                { propName: 'BANK_NAME',labelName: this.$t('home.bankName'),width: '120' },
                { propName: 'BANK_BRANCH',labelName: this.$t('home.bankBranch'),width: '120' },
                { propName: 'CARD_NUMBER',labelName: this.$t('home.bankAccount'),width: '120' }, */
                { propName: 'CARD_NUMBER',labelName: this.$t('withdraw.draw_bank_account'),width: '120',isShow: true },
                { propName: 'BANK_NAME',labelName: this.$t('withdraw.draw_bank_name'),width: '100',isShow: true },
                { propName: 'BENEFICIARY_NAME',labelName: this.$t('withdraw.draw_beneficiary'),width: '130',isShow: true },
                { propName: 'SWIFT_CODE',labelName: this.$t('withdraw.draw_swift'),width: '180',isShow: true },
                { propName: 'BANK_COUNTRY',labelName: this.$t('withdraw.draw_country'),width: '120',isShow: true },
                { propName: 'BANK_CITY',labelName: this.$t('withdraw.draw_city'),width: '120',isShow: true },
                { propName: 'IBAN_CODE',labelName: 'IBAN',width: '100',isShow: true },
                { propName: 'ABA',labelName: 'ABA',width: '100',isShow: true },
                { propName: 'SORT_CODE',labelName: 'Sort Code',width: '100',isShow: true },
                { propName: 'BSB',labelName: 'BSB',width: '100',isShow: true },
                { propName: 'INTERMEDIARY_BANK_NAME',labelName: 'Intermediary Bank Name',width: '180',isShow: true },
                { propName: 'INTERMEDIARY_COUNTRY_CODE',labelName: 'Intermediary Bank Country',width: '200',isShow: true },
                { propName: 'INTERMEDIARY_SWIFT_CODE',labelName: 'Intermediary Swift Code',width: '180',isShow: true },
                { propName: 'STATUS',labelName: this.$t('home.status'),width: '90',isShow: true },
                { propName: 'CREATE_TIME',labelName: this.$t('home.regDate'),width: '150',isShow: false }
            ],
            currentPage: 1,
            pageSize: 15,
            total: 0,
            userTableHeight: 0,
            withdrawStatus: '',
            statusOptions: [
                {
                    label: this.$t('home.inHand'),
                    value: 0
                },
                {
                    label: this.$t('home.figureOut'),
                    value: 1
                },
                {
                    label: this.$t('home.rejected'),
                    value: 2
                },
                {
                    label: this.$t('home.canceled'),
                    value: 3
                }
            ],
            keyWord: '',
            checkLoading: false,
            confirmLoading: false,
            cancleLoading: false,
            editVisible: false,
            editWithdrawForm: '',
            editWithdrawForm: {
                withdrawId: '',
                login_holder: '',
                username: '',
                currency: '',
                amount: '',
                charge: '',
                card_number: '',
                bank_name: '',
                beneficiary_name: '',
                swift_code: '',
                info_type: '',
                info_value: '',
                bank_address1: '',
                bank_address2: '',
                bank_country: '',
                bank_city: '',
                post_code: '',
                require_intermediary: false,
                intermediary_bank_name: '',
                intermediary_country_code: '',
                intermediary_swift_code: '',
                additional_information: ''
            },
            full_name: '',
            currencyOptions: [
                {
                    label: 'USD($)',
                    value: 1
                }
            ],
            editRules: {
                /* login_holder: [
                    { required: true, message: '输入账户持有者姓名', trigger: 'blur' }
                ],
                username: [
                    { required: true, message: '输入交易账户号码', trigger: 'blur' }
                ], */
                currency: [
                    { required: true, message: this.$t('home.selectCurrency'), trigger: 'blur' }
                ],
                amount: [
                    { validator: this.validateAmount,required: true, trigger: 'blur' }
                ],
                charge: [
                    { validator: this.validateCharge,required: true, trigger: 'blur' }
                ],
                /* full_name: [
                    { required: true, message: '收款人姓名', trigger: 'blur' }
                ], */
               /*  card_number: [
                  { required: true, message: this.$t('withdraw.isRequired'), trigger: 'blur' },
                  { pattern: /^\d{15,45}$/ ,message: this.$t('withdraw.least_fifteen'), trigger:['blur']}
                ], */
                card_number: [
                    {
                        required: true,
                        trigger: ["blur"],
                        validator: this.validateBankCard
                    }
                ],
                bank_name: [{ required: true, message: this.$t('withdraw.isRequired'), trigger: 'blur' }],
                swift_code: [{ required: true, message: this.$t('withdraw.isRequired'), trigger: 'blur' }],
                info_value: [{ required: false, message: this.$t('withdraw.isRequired'), trigger: 'blur' }],
                bank_address1: [
                { required: true, message: this.$t('withdraw.isRequired'), trigger: 'blur' }
                ],
                bank_country: [{ required: true, message: this.$t('withdraw.isRequired'), trigger: 'blur' }],
                bank_city: [{ required: true, message: this.$t('withdraw.isRequired'), trigger: 'blur' }],
                post_code: [{ required: true, message: this.$t('withdraw.isRequired'), trigger: 'blur' }],
                intermediary_bank_name: [{ required: false, message: this.$t('withdraw.isRequired'), trigger: 'blur' }],
                intermediary_country_code: [{ required: false, message: this.$t('withdraw.isRequired'), trigger: 'blur' }],
                intermediary_swift_code: [{ required: false, message: this.$t('withdraw.isRequired'), trigger: 'blur' }],
            },
            editLoading: false,
            recordVisible: false,
            recordKeyword: null,
            dateValue: null,
            recordLoading: false,
            recordTable: [],
            recordTableHead: [
                { propName: 'ORDER_ID',labelName: this.$t('table.orderId'),width: '100' },
				{ propName: 'TICKET',labelName: this.$t('table.ticket'),width: '100' },
				{ propName: 'ACCOUNT',labelName: this.$t('table.accountId'),width: '100' },
				{ propName: 'LOGIN',labelName: this.$t('table.account'),width: '80' },
				{ propName: 'OPEN_TIME',labelName: this.$t('table.positionOpentime'),width: '150' },
				{ propName: 'CMD',labelName: this.$t('table.type'),width: '100' },
				{ propName: 'SYMBOL',labelName: this.$t('table.symbol'),width: '100' },
				{ propName: 'VOLUME',labelName: this.$t('indexLang.volume'),width: '100' },
                { propName: 'CLOSE_TIME',labelName: this.$t('table.closeTime'),width: '150' },
                { propName: 'CREATE_TIME',labelName: this.$t('table.createTime'),width: '150' },
				{ propName: 'PROFIT',labelName: this.$t('table.commiss'),width: '100' },
				{ propName: 'COMMENT',labelName: this.$t('table.note'),width: '100' }
            ],
            recordCurrentPage: 1,
            recordPageSize: 15,
            recordTotal: 0,
            currentLogin: null,
            countData: [
                {label: this.$t('other.total') +'：',value: '0'},
                {label: this.$t('other.commissionTotal') +'：',value: '0'},
                {label: this.$t('other.IBAccount') +'：',value: '0'},
                {label: this.$t('other.tradingAccount') +'：',value: '0'},
				{label: this.$t('other.transactionNumber') +'：',value: '0'},
				{label: this.$t('home.balance') +'：',value: '0'}
            ],
            lastChildDate: null,
            exportLoading: false
        }
    },
    computed: {
        recevingOptions(){
            return [
                { label: 'IBAN(EU)', value: 'iban' },
                { label: 'ABA(US)', value: 'aba' },
                { label: 'Sort Code(UK)', value: 'sort_code' },
                { label: 'BSB(Australia)', value: 'bsb' }
            ]
        },
    },
    mounted(){
        /* 根据不同屏幕大小设定table高度 */
        this.userTableHeight = window.innerHeight - 315;
        this.reloadWithdrawList();
    },
    methods: {
        /* 银行卡验证 */
        validateBankCard(rule, value, callback) {
            if (value === "") {
                callback(new Error(this.$t("withdraw.isRequired")));
            } else {
                if(isNaN(value)){
                    callback(new Error(this.$t("other.formatError")));
                }else{
                    if(!/^\d{4,10000}$/.test(value)){
                        callback(new Error(this.$t("other.formatError")));
                    }else {
                        callback();
                    }
                }
            }
        },
        recevingChange(v){
            this.$refs.info_value.resetField();
            this.editRules.info_value[0].required = v ? true : false;
        },
        intermediaryChange(v){
            this.$refs.intermediary_bank_name.resetField();
            this.$refs.intermediary_country_code.resetField();
            this.$refs.intermediary_swift_code.resetField();
            this.editRules.intermediary_bank_name[0].required = this.editRules.intermediary_country_code[0].required = this.editRules.intermediary_swift_code[0].required = v;
        },
        /* 导出excel */
        toReportExcel(){
            //let tData = copyArr(this.tableData);
            let params = {
                keyword: this.keyWord,
                page: 1,
                page_size: this.total,
                status: this.withdrawStatus
            }
            this.exportLoading = true;
            withdrawCheckList(params).then( v => {
                this.exportLoading = false;
                if(v.code == 0){
                    let tData = v.data.row;
                    if(tData.length > 0){
                        let tDataKeys = [];
                        this.tableHead.map( v => {
                            tDataKeys.push(v.propName);
                        });
                        tDataKeys.push('WITHDRAW_COUNT');
                        tDataKeys.push('CARD_STATUS');
                        tDataKeys.push('NEGATIVE_STATUS');
                        tData.forEach( j => {
                            /* 处理当前状态 */
                            switch(j.STATUS){
                                case '0':
                                    j.STATUS = this.$t('home.inHand');
                                    break;
                                case '1':
                                    j.STATUS = this.$t('home.figureOut');
                                    break;
                                case '2':
                                    j.STATUS = this.$t('home.rejected');
                                    break;
                                case '3':
                                    j.STATUS = this.$t('home.canceled');
                                    break;
                            }
                            /* 处理第几次出金 */
                            j.WITHDRAW_COUNT = j.WITHDRAW_COUNT == '0' ? this.$t('other.firstWithdraw') : this.$t('other.isWithdrawed') + j.WITHDRAW_COUNT + this.$t('other.time');
                            /* 是否验证 */
                            j.CARD_STATUS = j.CARD_STATUS == '1' ? this.$t('other.checked') : this.$t('other.noChecked');
                            /* 是否有负值 */
                            if(j.NEGATIVE_STATUS == '1'){
                                let negativeStr = '';
                                j.NEGATIVE_LOGIN.forEach( v => {
                                    negativeStr += v.LOGIN +':'+ v.BALANCE +',';
                                })
                                j.NEGATIVE_STATUS = negativeStr.slice(0,-1);
                            }else{
                                j.NEGATIVE_STATUS = this.$t('other.plus');
                            }
                        })
                        exportExcelMethod(tData,tDataKeys,tDataKeys,'withdraw-check');
                    }else{
                        this.$message({
                            type: 'warning',
                            message: this.$t('home.noData')
                        })
                    }
                }else{
                    this.$message({
                        message: v.msg,
                        type: 'error'
                    });
                }
            })


            
        },
        /* 金额验证 */
        validateAmount(rule, value, callback){
            if(value === ''){
                callback(this.$t('home.enterAmount'));
            }else{
                var ptn = /^\d+(?=\.{0,1}\d+$|$)/;
                var res = ptn.test(value);
                if(!res){
                    callback(this.$t('placeholder.enterCorrectMoney'));
                }else{
                    if(value > Number(this.login_balance)){
                        callback(this.$t('placeholder.lackBalance'));
                    }
                    callback();
                }
            }
        },
        validateCharge(rule, value, callback){
            if(value === ''){
                callback(this.$t('home.enterCharge'));
            }else{
                var ptn = /^\d+(?=\.{0,1}\d+$|$)/;
                var res = ptn.test(value);
                if(!res){
                    callback(this.$t('placeholder.enterCorrectMoney'));
                }else{
                    callback();
                }
            }
        },
        /* 出金申请列表 */
        reloadWithdrawList(){
            let params = {
                keyword: this.keyWord,
                page: this.currentPage,
                page_size: this.pageSize,
                status: this.withdrawStatus
            }
            this.checkLoading = true;
            withdrawCheckList(params).then( v => {
                this.checkLoading = false;
                if(v.code == 0){
                    let tData = v.data.row;
                    tData.map( data => {
                        data.affirmBtnLoading = false;
                        data.refuseBtnLoading = false;
                        data.chargeValue = data.CHARGE;
                        //data.CARD_STATUS = 2;
                    })
                    this.tableData = tData;
                    this.total = v.data.total*1;
                }else{
                    this.$message({
                        message: v.msg,
                        type: 'error'
                    });
                }
            })
        },
        handleSizeChange(v){
            this.currentPage = 1;
            this.pageSize = v;
            this.reloadWithdrawList();
        },
        handleCurrentChange(v){
            this.currentPage = v;
            this.reloadWithdrawList();
        },
        /* 管理员 出金申请确认 */
        toSubmitWithdraw(row){
            this.$confirm(`${row.LOGIN_HOLDER}(${row.LOGIN})${this.$t('other.confirmDeductions')}：${row.AMOUNT}？`, this.$t('home.hint'), {
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancle'),
                type: 'warning'
            }).then(() => {
                let params = {
                    withdraw_id: row.WITHDRAW_ID
                }
                row.affirmBtnLoading = true;
                withdrawSubmit(params).then( v => {
                    row.affirmBtnLoading = false;
                    if(v.code == 0){
                        this.$message({
                            message: this.$t('home.confimApp'),
                            type: 'success'
                        });
                        this.reloadWithdrawList();
                    }else{
                        this.$message({
                            message: v.msg,
                            type: 'error'
                        });
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: this.$t('home.canceled')
                });          
            }); 
        },
        getUserBalance(){
            getNewBalance().then( v => {
                if(v.code == 0){
                    let userSession = JSON.parse(sessionStorage.getItem('user_info'));
                    userSession.BALANCE = v.data.BALANCE;
                    sessionStorage.setItem('user_info',JSON.stringify(userSession));
                }else{
                    this.$message({
                        type: 'error',
                        message: v.msg
                    })
                }
            })
        },
        /* 管理员 拒绝出金申请 */
        toRejectWithdraw(row){
            this.$prompt(this.$t('home.enterRefuseReason'), this.$t('home.hint'), {
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancle'),
            }).then(({ value }) => {
                let params = {
                    withdraw_id: row.WITHDRAW_ID,
                    reject_reason: value
                }
                row.refuseBtnLoading = true;
                withdrawReject(params).then( (v) => {
                    row.refuseBtnLoading = false;
                    if(v.code == 0){
                        this.$message({
                            message: this.$t('home.rufuseApp'),
                            type: 'success'
                        });
                        this.reloadWithdrawList();
                    }else{
                        this.$message({
                            message: v1.msg,
                            type: 'error'
                        });
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: this.$t('home.canceled')
                });       
            });
        },
        /* 根据状态筛选出金申请 */
        selectWithdraw(){
            if(!this.withdrawStatus){
                this.tableHead.map( v => {
                    if(v.propName == 'UPDATE_TIME'){
                        v.isShow = false;
                    }
                })
            }else{
                this.tableHead.map( v => {
                    if(v.propName == 'UPDATE_TIME'){
                        v.isShow = true;
                    }
                })
            }
            this.reloadWithdrawList();
        },
        /* 修改出金申请信息 */
        toEditWithdraw(row){
            this.editVisible = true;
            this.full_name = row.FULL_NAME;
            this.editWithdrawForm.withdrawId = row.WITHDRAW_ID;
            this.editWithdrawForm.login_holder = row.LOGIN_HOLDER;
            this.editWithdrawForm.username = row.LOGIN;
            this.editWithdrawForm.currency = row.CURRENCY;
            this.editWithdrawForm.amount = row.AMOUNT;
            this.editWithdrawForm.charge = row.CHARGE;
            this.editWithdrawForm.card_number = row.CARD_NUMBER;
            this.editWithdrawForm.bank_name = row.BANK_NAME;
            this.editWithdrawForm.beneficiary_name = row.BENEFICIARY_NAME;
            this.editWithdrawForm.swift_code = row.SWIFT_CODE;
            this.editWithdrawForm.bank_address1 = row.BANK_ADDRESS1;
            this.editWithdrawForm.bank_address2 = row.BANK_ADDRESS2;
            this.editWithdrawForm.bank_country = row.BANK_COUNTRY;
            this.editWithdrawForm.bank_city = row.BANK_CITY;
            this.editWithdrawForm.post_code = row.POST_CODE;
            this.editWithdrawForm.require_intermediary = row.REQUIRE_INTERMEDIARY === '1' ? true : false;
            this.editWithdrawForm.intermediary_bank_name = row.INTERMEDIARY_BANK_NAME;
            this.editWithdrawForm.intermediary_country_code = row.INTERMEDIARY_COUNTRY_CODE;
            this.editWithdrawForm.intermediary_swift_code = row.INTERMEDIARY_SWIFT_CODE;
            this.editWithdrawForm.additional_information = row.ADDITIONAL_INFORMATION;
            if(row.IBAN_CODE || row.ABA || row.SORT_CODE || row.BSB){
                if(row.IBAN_CODE){
                    this.editWithdrawForm.info_type = 'iban';
                    this.editWithdrawForm.info_value = row.IBAN_CODE;
                }
                if(row.ABA){
                    this.editWithdrawForm.info_type = 'aba';
                    this.editWithdrawForm.info_value = row.ABA;
                }
                if(row.SORT_CODE){
                    this.editWithdrawForm.info_type = 'sort_code';
                    this.editWithdrawForm.info_value = row.SORT_CODE;
                }
                if(row.BSB){
                    this.editWithdrawForm.info_type = 'bsb';
                    this.editWithdrawForm.info_value = row.BSB;
                }
            }
        },
        /* 关闭修改出金申请 dialog */
        handleClose(){
            this.editVisible = false;
        },
        /* 修改出金申请 提交 */
        editSubmit(){
            this.$refs.editWithdrawForm.validate( (valid) => {
                if(valid){
                    this.editWithdrawForm[this.editWithdrawForm.info_type] = this.editWithdrawForm.info_value;
                    let params = {
                        full_name: this.full_name,
                        ...this.editWithdrawForm,
                        withdraw_id: this.editWithdrawForm.withdrawId,
                        require_intermediary: this.editWithdrawForm.require_intermediary ? 1 : 0

                        /* withdraw_id: this.editWithdrawForm.withdrawId,
                        login_holder: this.login_holder,
                        username: this.username,
                        currency: this.editWithdrawForm.currency,
                        amount: Number(this.editWithdrawForm.amount),
                        charge: Number(this.editWithdrawForm.charge),
                        full_name: this.full_name,
                        bank_country: this.editWithdrawForm.bank_country,
                        bank_name: this.editWithdrawForm.bank_name,
                        bank_province: this.editWithdrawForm.bank_province,
                        bank_city: this.editWithdrawForm.bank_city,
                        bank_branch: this.editWithdrawForm.bank_branch,
                        card_number: this.editWithdrawForm.card_number,
                        sort_code: this.editWithdrawForm.sort_code,
                        swift_code: this.editWithdrawForm.swift_code,
                        iban_code: this.editWithdrawForm.iban_code, */
                    }
                    this.editLoading = true;
                    editWithdraw(params).then( v => {
                        if(v.code == 0){
                            this.editVisible = false;
                            this.reloadWithdrawList();
                            this.$message({
                                message: this.$t('placeholder.editSuccess'),
                                type: 'success'
                            })
                        }else{
                            this.$message({
                                message: v.msg,
                                type: 'error'
                            })
                        }
                        this.editLoading = false;
                    })
                }
            })
        },
        /* 查看当前点击账户的信息 dialog */
        showBalanceRecord(row){
            this.recordVisible = true;
            this.$nextTick( () => {
				let tableObj = this.$refs.recordTable.$el.getElementsByClassName('el-table__body-wrapper')[0];
				tableObj.scrollLeft = 0;
            })
            this.currentLogin = row.LOGIN;
            this.reloadRecordList();
        },
        /* 关闭余额变动记录 dialog */
        recordClose(){
            this.recordVisible = false;
        },
        changeDate(){
            if(this.dateValue == this.lastChildDate){
                return;
            }else{
                this.lastChildDate = this.dateValue;
                this.reloadRecordList();
            }
        },
        recordSizeChange(v){
            this.recordCurrentPage = 1;
            this.recordPageSize = v;
            this.reloadRecordList();
        },
        recordCurrentChange(v){
            this.recordCurrentPage = v;
            this.reloadRecordList();
        },
        reloadRecordList(){
            let params = {
                login: this.currentLogin,
                keyword: this.recordKeyword,
				page: this.recordCurrentPage,
				page_size: this.recordPageSize
			}
			if(this.dateValue && this.dateValue.length > 0){
				params.start_time_format = this.dateValue[0];
				params.end_time_format = this.dateValue[1];
			}
			this.recordLoading = true;
			this.recordTable = [];
			getBalanceRecord(params).then( data => {
                this.recordLoading = false;
                let statistic = data.data.statistic;
				if(data.code == 0){
					let tData = data.data.row;
					tData.map( v => {
						switch(v.CMD){
							case '0':
								v.CMD = 'buy';
								break;
							case '1':
								v.CMD = 'sell';
								break;
							case '8':
								v.CMD = 'withdrawal';
								break;
							case '9':
								v.CMD = 'charge';
								break;
							default:
								v.CMD = '-';
								break;
						}
					})
					this.recordTable = tData;
                    this.recordTotal = data.data.total*1;
                    this.countData[0].value = statistic.count;
                    this.countData[1].value = statistic.profit_all;
                    this.countData[2].value = statistic.account_count;
                    this.countData[3].value = statistic.login_count;
                    this.countData[4].value = statistic.volume_all;
                    this.countData[5].value = statistic.balance;
                }
			})
        },
        /* 修改手续费 */
        toEditCharge(row){
            this.$confirm(this.$t('other.sureEditCharge'), this.$t('home.hint'), {
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancle'),
                type: 'warning'
            }).then(() => {
                let params = {
                    withdraw_id: row.WITHDRAW_ID,
                    charge: row.chargeValue
                }
                updateCharge(params).then( v => {
                    if(v.code == '0'){
                        this.$message({
                            type: 'success',
                            message: this.$t('placeholder.editSuccess')
                        }); 
                    }
                })
            }).catch(() => {
                row.chargeValue = row.CHARGE;
                this.$message({
                    type: 'info',
                    message: this.$t('home.canceled')
                });          
            }); 
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.withdrawCheck{
    .applyPage{
        margin-top: 20px;
        text-align: right;
    }
    .recordPage{
        margin-top: 15px;
    }
    .historySum{
        margin-bottom: 5px;
        display: inline-block;
        .sumLabelFont{
            margin-left: 20px;
            font-size: 12px;
        }
        .sumNumberFont{
            font-weight: bold;
            color: #00AFFF;
            font-size: 14px;
        }
    }
    .withdrawCountTip{
        cursor: pointer;
    }
    .countIcon{
        width:22px;
        height:22px;
        display:inline-block;
        background:#00abff;
        vertical-align: middle;
        line-height:22px;
        text-align: center;
        border-radius:10px;
        font-size:12px;
        color: #fff;
        margin-bottom:0px;
    }
    .negative{
        background: #67c23a;
    }
    .warningCharge{
        color: #e6a23c;
    }
    .successCharge{
        color: #67c23a;
    }
}
</style>
<style>
.operation-class{
    cursor: pointer;
}
.operation-class .el-button--mini,.operation-class .el-button--mini.is-round{
    padding: 5px 10px;
    width: 70px;
}
.withdrawCheck .el-card__header{
    padding: 8px 20px;
    line-height: 40px;
}
.checkKey .el-input{
    width: 217px;
}
.user-tooltip{
	max-width: 20%;
} 
.holder-class{
    color: #00AFFF;
}
.holder-class:hover{
    cursor: pointer;
    text-decoration: underline;
}
.recordDialog .el-dialog__body{
    padding-top: 0px;
    padding-bottom: 20px;
}
.recordDialog .el-dialog__header{
    padding-left: 20px;
    padding-top: 20px;
}
.applyTable .el-icon-my-iconcj{
    font-size: 22px;
    color: #00AFFF;
    vertical-align: middle;
}
.applyTable .el-icon-my-sh,.applyTable .el-icon-my-weirenzheng,.applyTable .el-icon-my-approve{
    font-size: 20px;
    vertical-align: middle;
}
.chargeEdit{
    width: 140px !important;
}
.chargeEdit .el-input__inner{
    height: 23px !important;
}
.chargeEdit .el-input__icon{
    line-height: 23px;
}
.iconEdit:hover{
    cursor: pointer;
    color: #00AFFF;
}
.warningCharge .el-input__inner{
    color: #e6a23c;
}
.successCharge .el-input__inner{
    color: #67c23a;
}
.negativeTooltip{
    max-height: 200px;
    overflow:auto;
}
.negativeDetail .el-table tr,.negativeDetail .el-table th{
    background: black;
    color: #FFF;
    text-align: center;
}
.negativeDetail el-table--enable-row-hover,.negativeDetail .el-table__body tr:hover>td{
    background: #00AFFF;
    cursor: pointer;
}
.applyTable .el-pagination--small .arrow.disabled,.applyTable .el-table .hidden-columns,.applyTable .el-table td.is-hidden>*,.applyTable .el-table th.is-hidden>*,.applyTable .el-table--hidden{
    visibility:visible !important;
}
.editWithdraw .el-select{
    width: 100%;
}
</style>




// WEBPACK FOOTER //
// withdrawCheck.vue?9b504eee